import NextClient, { Props } from './client';
import { fetchURL } from './data-fetcher';
import * as ReactDOM from 'react-dom/client';
import React, { useEffect, useRef } from 'react';
import System from '../../system';
import animejs from 'animejs';
import events from 'events';
import * as vev from '../../core';
import { fetchDeps, importAll } from './utils';

export default function Fetch(props: Props) {
  const app = useRef<any>();
  const mounted = useRef<string>();

  const isDevelopment = process.env.NODE_ENV === 'development' || props.noCache;

  const url = `https://embed.vev.${props.dev ? 'space' : 'page'}/v1/${props.projectKey}/${
    props.pageKey
  }?type=json${isDevelopment ? '&nocache' : ''}`;
  const { data, promise, resolved } = fetchURL<any>(url);
  if (!resolved) throw promise;

  useEffect(() => {
    if (mounted.current || !data.html || !app.current) return;
    mounted.current = 'done';

    (async () => {
      (window as any).vev = vev;

      System.add({
        vev,
        react: { default: React, ...React },
        animejs: { default: animejs },
        events: { default: events },
      });

      (window as any).vevr = {
        push: (cb: any) => cb(vev, System, React),
      };

      await fetchDeps(data.scripts.filter((s: string[]) => !s.includes('vev.js')));
      await Promise.all([importAll(data?.json)]);

      if (!app.current?.children) return;
      const [container] = app.current.children;
      const jsx = <NextClient {...data} />;

      if (ReactDOM.hydrateRoot) {
        ReactDOM.hydrateRoot(container, jsx);
      } else {
        // @ts-expect-error - ajo Reroute to preact hydrate
        react.hydrate(jsx, container);
      }
    })();
  }, [mounted.current, resolved]);

  if (!data) return null;

  return (
    <div style={{ position: 'relative' }}>
      <style dangerouslySetInnerHTML={{ __html: data?.css }} />
      <div ref={app} dangerouslySetInnerHTML={{ __html: data?.html }} />
    </div>
  );
}
